import { HttpCalendarService } from "@root/component/multi-calendar/http-calendar.service";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

import moment, { Moment } from "moment";
import { head, last, get } from "lodash";
import { PlatformType } from "@root/config";
import { StoreService } from "@root/shared/service/store.service";
import { Subject, distinctUntilChanged, share, takeUntil, tap } from "rxjs";
import {
  PriceChild,
  MultiHouseCalendarService,
  SelectedData,
  Child,
  TabName,
} from "../../calendar/multi-house-calendar/multi-house-calendar.service";
import { BatchModifyRestrictionsService } from "@root/router/price/batch-modify-restrictions/batch-modify-restrictions.service";

@Component({
  selector: "host-operate-channel-sidebar",
  templateUrl: "./channel-sidebar.component.html",
  styleUrls: ["./channel-sidebar.component.scss"],
})
export class ChannelSidebarComponent implements OnInit {
  @Input() selectedData: SelectedData<"house", "price">;
  @Output() onUpdated = new EventEmitter();
  index = 0;

  /**
   * 当前实体
   * 如果选择的是房间，entity代表的是房间数据，类型为Child
   * 如果选择的是房型，entity代表的是房型数据，类型为Parent
   * Child可以通过c_parent属性反向寻找到自己的Parent相关的信息
   *
   *  房价页面该类型永远为 Child
   */
  entity: PriceChild;
  dateRange: Array<Date> = [];
  listOfForbiddenDates = [];
  listOfPriceCalendar = []; // 房价日历专用
  listOfRulesSettingHouse = []; // rules

  get nights() {
    const h = moment(head(this.dateRange));
    const l = moment(last(this.dateRange));
    return l.diff(h, "days") + 1;
  }

  private tabChange$ = this.calendarSrv.sidebarTabRaw$.pipe(
    distinctUntilChanged(),
    tap((value) => this.updateTabIndex(value.type)),
  );

  private dateChange$ = this.calendarSrv.selectRaw$.pipe(
    distinctUntilChanged(),
    tap((value: SelectedData<"house", "price">) => {
      this.updateDateRange(value);
    }),
    share(),
  );

  private destroy$ = new Subject();

  constructor(
    private deprecatedSrv: HttpCalendarService,
    private calendarSrv: MultiHouseCalendarService,
    private restrictionsSrv: BatchModifyRestrictionsService,
    private store: StoreService,
  ) {}

  ngOnInit() {
    this.tabChange$.pipe(takeUntil(this.destroy$)).subscribe();
    this.dateChange$.pipe(takeUntil(this.destroy$)).subscribe();

    const data = this.selectedData
      ? this.selectedData
      : (this.calendarSrv.selectedData as SelectedData<"house", "price">);
    this.updateDateRange(data);
    this.updateEntityData(data);

    this.fetchPriceInfo();
  }

  private updateEntityData(data: SelectedData<"house", "price">) {
    this.entity = data.data.payload;
  }

  private updateDateRange(value: SelectedData<"house", "price">) {
    const dates = value.dates;
    const head: Moment = get(dates, "head") || moment();
    const last: Moment = get(dates, "last") || moment();

    this.dateRange = [head.toDate(), last.toDate()];
  }

  /**
   *  渠道侧边栏获取价格接口
   *  改价、渠道库存/房态  页需要 listOfPriceCalendar
   *  获取到该数据之后，过滤出符合条件的数据，就是 listOfRulesSettingHouse，房价预定规则需要
   */
  private fetchPriceInfo() {
    const unique_keys = (this.entity as Child)?.c_parent?.p_children_ids;

    const [begin, end] = [
      moment(head(this.dateRange)).format("YYYY-MM-DD"),
      moment(last(this.dateRange)).format("YYYY-MM-DD"),
    ];

    const params = {
      unique_keys: JSON.stringify(unique_keys),
      begin,
      end,
      version: "2.4",
    };
    this.deprecatedSrv.getCalendarListV2(params).subscribe((res) => {
      const list = res?.data?.list || [];
      this.listOfPriceCalendar = list.map((item) => ({
        ...item,
        house_info: (this.entity as Child)?.c_parent.p_children.find((key) => key.c_id === item.unique_key),
      }));

      this.listOfRulesSettingHouse = this.listOfPriceCalendar
        .filter((item) => this.restrictionsSrv.isSupportRestrictions(item.thirdparty_type))
        .map((item) => ({ ...item, thirdparty_house_title: item.house_info?.thirdparty_house_title }));

      this.updateTabIndex();
    });
  }

  updateTabIndex(name?: TabName) {
    console.log("updateTabIndex: ", name);

    const map: Partial<Record<TabName, number>> = {
      "channel-price": 0,
      "rules-setting": 1,
      "channel-status": this.listOfRulesSettingHouse.length ? 2 : 1,
    };

    const key = "operate-channel-sidebar-tab-name";
    const value = this.store.get(key, 2) || 0;

    if (name !== undefined) {
      this.store.set(key, name, 2);
      this.index = map[name];
    } else {
      this.index = map[value];
    }
  }

  onClickCancel() {
    console.log("on click cancel");
    this.calendarSrv.cancelSelect();
  }
}
